import { Metafield } from './metafield'

export interface Link {
  title: string
  to: string
  type: string
  links?: Array<Link>
}

export interface Linklist {
  handle: string
  links: Array<Link>
}

export interface Space {
  id: string
  name: string
  domain: string
  linklists: Array<Linklist>
  metafields: Array<Metafield>
}

export interface CreateSpaceOptions {
  id?: string
  name?: string
  domain?: string
  linklists?: Array<Linklist>
  metafields?: Array<Metafield>
}

export const createSpace = (obj: CreateSpaceOptions): Space => {
  const { id, name, domain, linklists, metafields } = obj
  const space = {
    id: id || '',
    name: name || '',
    domain: domain || '',
    linklists: Array.isArray(linklists) ? linklists : [],
    metafields: Array.isArray(metafields) ? metafields : []
  }

  return space
}
